import React, {useEffect, useState} from "react";
import {getAllSearchCompletions} from "../service/api";
import parseHtml from "html-react-parser";
import {useTranslation} from "../hooks/useTranslation";

type CompletionsProps = {
    searchText : string,
    searchResultLink: string,
}

export function SearchCompletions({searchText, searchResultLink}: CompletionsProps) {

    const [completions, setCompletions] = useState<string[]>([]);

    const translate = useTranslation();

    useEffect(()=> {
        if(searchText) {
            getAllSearchCompletions(searchText)
                .then(response => {
                    setCompletions(response.autocomplete)
                })
        } else {
            setCompletions([])
        }
    }, [searchText]);

    return (
        <div className='search__completion col-12 col-lg-4'>
            <div className='search__suggestion--title'>{translate('search.completions.title')}</div>

            {completions
                .map(completion => {
                    const urlCompletion = completion.replace(/(<([^>]+)>)/gi, "");

                    return <div className='search__completionWrapper'>
                        <a href={searchResultLink + '?search=' + urlCompletion}>
                            {parseHtml(`${completion}`)}
                        </a>
                    </div>
                })
            }
        </div>
    );
}
